<template>
  <v-container v-if="location">
    <NormalInput
      :id="props.locationId"
      class="mb-4"
      field="name"
      :rules="[required]" />

    <NormalInput
      :id="props.locationId"
      class="mb-4"
      field="description"
      :rules="[]" />

    <NormalInput
      :id="props.locationId"
      class="mb-4"
      field="address_location"
      :rules="[]" />

    <CarouselWithUpload
      field="location_images"
      :node-id="props.locationId" />
  </v-container>
</template>

<script setup>
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import { ref, onMounted } from "vue";
import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";

const { t } = useTranslation();

const location = ref(null);
const { required } = useCommonRules(t);

const spaceStore = useSpaceStore();
const props = defineProps({
  locationId: {
    type: String,
    required: true
  }
});
onMounted(() => {
  location.value = spaceStore.getElement(props.locationId);
});
</script>
